import React from 'react';
import { Link } from 'react-router-dom';
import './ISO50001.css';

const ISO50001 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 50001 Energy Management System</h1>
            <h2 className="page-subtitle">ISO 50001: Optimize Energy, Empower the Future!</h2>
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we support our commitments to energy efficiency 
                with the ISO 50001 Energy Management System. In this article, we will thoroughly discuss 
                what ISO 50001 is, its role in energy management, the advantages it provides to businesses, 
                and how it is implemented.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 50001?</h2>
            <div className="page-text-content">
              <p>
                ISO 50001 is an international standard for energy management systems. This standard guides 
                businesses that aim to increase energy efficiency, reduce energy costs, and establish a 
                sustainable energy management culture. ISO 50001 includes a commitment for businesses to 
                monitor, measure, analyze, and continually improve their energy consumption.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Elements of ISO 50001:</h2>
            <div className="elements-list">
              <div className="element-item">
                <h3 className="element-title">1. Energy Policy</h3>
                <p className="element-description">
                  ISO 50001 requires businesses to establish specific and measurable energy policies and 
                  implement them.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">2. Planning</h3>
                <p className="element-description">
                  Businesses evaluate energy usage, set targets, and develop action plans to continually 
                  improve energy performance.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">3. Implementation and Monitoring</h3>
                <p className="element-description">
                  Implementing plans according to defined energy targets and continuously monitoring this 
                  process are key elements of ISO 50001.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">4. Evaluation and Improvement</h3>
                <p className="element-description">
                  Businesses regularly assess their energy performance and take measures for continuous 
                  improvement.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of ISO 50001 for Businesses:</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">1. Energy Efficiency</h3>
                <p className="advantage-description">
                  ISO 50001 increases energy efficiency by enabling businesses to optimize their energy usage.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">2. Cost Savings</h3>
                <p className="advantage-description">
                  Tracking and reducing energy costs provide significant cost savings to businesses.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">3. Environmental Performance</h3>
                <p className="advantage-description">
                  More efficient energy use reduces environmental impacts and brings businesses closer to 
                  sustainability goals.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">4. Legal Compliance</h3>
                <p className="advantage-description">
                  ISO 50001 facilitates compliance with legal regulations related to energy management.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">5. Corporate Reputation</h3>
                <p className="advantage-description">
                  Having ISO 50001 certification gives businesses a leadership role in energy management 
                  and enhances their corporate reputation.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How is ISO 50001 Implemented?</h2>
            <div className="page-text-content">
              <p>
                The implementation process of ISO 50001 can vary depending on the size and complexity of 
                the organization. However, generally, the implementation steps can be summarized as follows:
              </p>
            </div>
            <div className="steps-list">
              <div className="step-item">
                <h3 className="step-title">1. Initial Assessment</h3>
                <p className="step-description">
                  Current energy usage and management processes are evaluated.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">2. Policy and Process Development</h3>
                <p className="step-description">
                  Appropriate energy policies and processes are determined for ISO 50001.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">3. Training and Communication</h3>
                <p className="step-description">
                  Personnel are trained on energy management topics, and continuous communication is 
                  maintained.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">4. Documentation and Monitoring</h3>
                <p className="step-description">
                  Documentation is created according to ISO 50001 requirements, and energy performance is 
                  regularly monitored.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">5. Audit and Improvement</h3>
                <p className="step-description">
                  Compliance with ISO 50001 standards is regularly audited, and action plans are developed 
                  for continuous improvement.
                </p>
              </div>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO50001;

